import React from 'react'
import Aux from '../hoc/Auxiliary'
import { NavLink } from 'react-router-dom'
import { withNamespaces } from 'react-i18next'

export const MainNav = props => {
    const { isHome, isSideNav, t } = props
    return <Aux>
        <ul className={`${!isHome && !isSideNav ? 'u-text--black' : ''} u-weight--normal main-nav`}>
            <li><NavLink to={'/apartments'}>{t('nav.apartments')}</NavLink></li>
            <li><NavLink to={'/location'}>{t('nav.location')}</NavLink></li>
            <li><NavLink to={'/materials'}>{t('nav.materials')}</NavLink></li>
            <li><NavLink to={'/about'}>{t('nav.about')}</NavLink></li>
            <li><NavLink to={'/payment'}>{t('nav.payment')}</NavLink></li>
        </ul>
        <ul>
            <li className='c-header__nav__btn'><NavLink className={`c-btn ${!isHome && !isSideNav ? 'u-bg--black u-text--white u-padding-horizontal' : 'c-btn--ghost'} u-weight--normal`} to={'/contact'}>{t('nav.contacts')}</NavLink></li>
        </ul>
    </Aux>
}

export default withNamespaces()(MainNav)



// WEBPACK FOOTER //
// ./src/components/MainNav.js